export function addCartCustomer(object) {
  return {
    type: "CART_ADD_CUSTOMER",
    payload: object,
  };
}
